(function() {

  var project_filter_group = $('.project-filter__group');

  $(project_filter_group).on(Modernizr.touch ? 'touchend' : 'click', 'h4', function() {
    $(this).parent().toggleClass('is-open');
  });

  // When the entire document is touched/clicked:
  $(document).on(Modernizr.touch ? 'touchstart' : 'mousedown', function(e) {
    // For each project filter group:
    $(project_filter_group).each(function() {
      // If it's already open and it, nor any of its children are the target of the touch/click:
      if ($(this).hasClass('is-open') && !$(this).is(e.target) && $(this).has(e.target).length === 0) {
        // Close it:
        $(this).removeClass('is-open');
      }
    });
  });

}());
